import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button, IconButton } from '@mui';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import './top-bar-navigation.scss';

const Navigation = ({ next, previous, today, selectedDate }) => (
  <div styleName="navigation-container">
    <div styleName="navigation-button">
      <Button plain onClick={today} variant="outlined">Today</Button>
    </div>
    <IconButton onClick={previous} size="small" aria-label="Previous">
      <KeyboardArrowLeft />
    </IconButton>
    <div styleName="navigation-sep" />
    <IconButton onClick={next} size="small" aria-label="Next">
      <KeyboardArrowRight />
    </IconButton>
    <div styleName="navigation-date">{selectedDate.format('MMMM YYYY')}</div>
  </div>
);

Navigation.propTypes = {
  next: PropTypes.func,
  previous: PropTypes.func,
  selectedDate: PropTypes.object,
  today: PropTypes.func
};

export default memo(Navigation);
